import { render, staticRenderFns } from "./walletkey.vue?vue&type=template&id=a5a46f6a&scoped=true&"
import script from "./walletkey.vue?vue&type=script&lang=js&"
export * from "./walletkey.vue?vue&type=script&lang=js&"
import style0 from "./walletkey.vue?vue&type=style&index=0&id=a5a46f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a46f6a",
  null
  
)

export default component.exports